import { FieldValues, Path, UseFormRegister } from "react-hook-form";

import RadioButton, { RadioOption } from "components/RadioButton";

const RadioButtonBar = <T extends FieldValues>({
  label,
  direction,
  name,
  options,
  register,
  defaultValue,
  required,
}: {
  label: string;
  name: Path<T>;
  register: UseFormRegister<T>;
  options: RadioOption[];
  required?: boolean;
  direction: "vertical" | "horizontal";
  defaultValue?: string | number;
}) => {
  return (
    <div className="my-10 flex h-20 w-full items-center justify-center gap-[38px] bg-check-box">
      <p className="text-16px">{label}</p>
      <RadioButton
        name={name}
        register={register}
        required={required}
        minWidth="min-w-[76px]"
        options={options}
        direction={direction}
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default RadioButtonBar;
